module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appt-req-form"
  }, [_c('form', {
    staticClass: "appt-req-form__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "appt-req-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "appt-req-form__input",
    class: {
      'input': true, 'appt-req-form__input--error': _vm.errors.has('full-name')
    },
    attrs: {
      "name": "full-name",
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "appt-req-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('full-name')),
      expression: "errors.has('full-name')"
    }]
  }, [_vm._v("Full name is required.")])])]), _c('div', {
    staticClass: "appt-req-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[2-9]\d{2}-\d{3}-\d{4}$/
      }),
      expression: "{required: true, regex: /^[2-9]\\d{2}-\\d{3}-\\d{4}$/}"
    }],
    staticClass: "appt-req-form__input",
    class: {
      'input': true, 'appt-req-form__input--error': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "appt-req-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }]
  }, [_vm._v("Valid phone number is required.")])])]), _c('div', {
    staticClass: "appt-req-form__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "appt-req-form__input",
    class: {
      'input': true, 'appt-req-form__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "appt-req-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }]
  }, [_vm._v("Valid email is required.")])])]), _c('div', {
    staticClass: "appt-req-form__group"
  }, [_c('p', [_vm._v("First Time Patient?")]), _c('div', {
    staticClass: "appt-req-form__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "appt-req-form__input--radio",
    attrs: {
      "name": "newPatient",
      "value": "Yes",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "Yes"
      }
    }
  }), _c('span', {
    staticClass: "appt-req-form__radio-overlay"
  }), _c('label', {
    staticClass: "appt-req-form__label"
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "appt-req-form__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "appt-req-form__input--radio",
    attrs: {
      "name": "newPatient",
      "value": "No",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "No")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "No"
      }
    }
  }), _c('span', {
    staticClass: "appt-req-form__radio-overlay"
  }), _c('label', {
    staticClass: "appt-req-form__label"
  }, [_vm._v("No")])])]), _c('div', {
    staticClass: "appt-req-form__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "appt-req-form__textarea",
    class: {
      'appt-req-form__textarea--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "textarea",
      "rows": "4",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "appt-req-form__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }]
  }, [_vm._v("Send us a message!")])])]), _c('div', {
    staticClass: "appt-req-form__button-group"
  }, [_c('button', {
    staticClass: "appt-req-form__submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.formSubmitted
    }
  }, [_vm._v("SUBMIT")]), (_vm.formSubmitted) ? _c('div', {
    staticClass: "appt-req-form__spinner"
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f0de128","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/forms/appt-req-form/appt-req-form.pug
// module id = 578
// module chunks = 1